import { ContentConnectorApollo } from '@front-activerse/common-components';
import TermsOfServiceContainer from './TermsOfServiceContainer';

const TermsOfServicePage = () => {
  return (
    <ContentConnectorApollo identifier="terms-of-service-android">
      {({ ...contentData }) => (
        <ContentConnectorApollo identifier="terms-of-service-ios">
          {({ ...contentData2 }) => (
            <ContentConnectorApollo identifier="terms-of-service-web">
              {({ ...contentData3 }) => (
                <ContentConnectorApollo identifier="terms-of-service-huawei">
                  {({ ...contentData4 }) => {
                    return (
                      <TermsOfServiceContainer
                        loading={
                          contentData.loading ||
                          contentData2.loading ||
                          contentData3.loading ||
                          contentData4.loading
                        }
                        content={contentData.content}
                        content2={contentData2.content}
                        content3={contentData3.content}
                        content4={contentData4.content}
                      />
                    );
                  }}
                </ContentConnectorApollo>
              )}
            </ContentConnectorApollo>
          )}
        </ContentConnectorApollo>
      )}
    </ContentConnectorApollo>
  );
};

export default TermsOfServicePage;
